"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClientFactory = exports.HttpClient = void 0;
var axios_1 = __importDefault(require("axios"));
var defaultConfig = function () { return ({
    timeout: 10000
}); };
var HttpClient = /** @class */ (function () {
    function HttpClient() {
    }
    HttpClient.initialize = function (config) {
        if (config === void 0) { config = {}; }
        if (!HttpClient.instance) {
            HttpClient.instance = HttpClientFactory.makeInstance(config);
        }
        return HttpClient.instance;
    };
    return HttpClient;
}());
exports.HttpClient = HttpClient;
var HttpClientFactory = /** @class */ (function () {
    function HttpClientFactory() {
    }
    HttpClientFactory.makeInstance = function (config) {
        if (config === void 0) { config = {}; }
        return axios_1.default.create(__assign(__assign({}, (defaultConfig())), config));
    };
    return HttpClientFactory;
}());
exports.HttpClientFactory = HttpClientFactory;
var httpClient = function (config) {
    if (config === void 0) { config = {}; }
    return HttpClient.initialize(config);
};
exports.default = httpClient;
//# sourceMappingURL=index.js.map